import { FC, ReactElement } from 'react'

import CalendarLegend from '../../../components/CalendarLegend/CalendarLegend'
import {
    Absence,
    LeaveOfAbsence,
    Shift,
    SpecialDayViewModel,
    UnavailableToWorkTimeSlot,
} from '../../../models'
import { ConnectedCalendarNavigation } from '../../connectors'
import { Track } from '../../entities/Track/Track'
import { TimeModeType } from '../../types'
import { UserCalendarDays } from './subcomponents'

import './UserCalendar.scss'

interface UserCalendarProps {
    isLoading: boolean;
    days: Date[];
    mobileDay: Date;
    userId: string;
    shifts: Shift[];
    specialDays: SpecialDayViewModel[];
    tracks: Track[];
    absences: Absence[];
    leaveOfAbsences: LeaveOfAbsence[];
    timeMode: TimeModeType;
    unavailableToWorkTimeSlots: UnavailableToWorkTimeSlot[];
    onItemClick: (object: Absence | LeaveOfAbsence | UnavailableToWorkTimeSlot) => void;
    className?: string;
}

const UserCalendar: FC<UserCalendarProps> = ({
    isLoading,
    absences,
    days,
    mobileDay,
    userId,
    shifts,
    specialDays,
    tracks,
    leaveOfAbsences,
    timeMode,
    unavailableToWorkTimeSlots,
    onItemClick,
    className = '',
}) => {
    const renderDays = (selectedDays: Date[], showHeader = true): ReactElement => (
        <UserCalendarDays
            absences={absences}
            leaveOfAbsences={leaveOfAbsences}
            shifts={shifts}
            tracks={tracks}
            showHeader={showHeader}
            selectedDays={selectedDays}
            specialDays={specialDays}
            unavailableToWorkTimeSlots={unavailableToWorkTimeSlots}
            isLoading={isLoading}
            onItemClick={onItemClick}
            userId={userId}
            mode={timeMode}
        />
    )

    return (
        <div className={`user-calendar ${className}`}>
            <div className="user-calendar__top">
                <ConnectedCalendarNavigation
                    showMobileControls
                    timeModes={[TimeModeType.period, TimeModeType.month]}
                    className="user-calendar__navigation"
                />

                <CalendarLegend
                    plannedShift
                    leaveOfAbsence
                    absence
                    notAvailable
                    unplannedTrack
                />
            </div>
            <div className="calendar-days-desktop user-calendar__days-desktop">
                {renderDays(days)}
            </div>
            <div className="calendar-days-mobile user-calendar__days-mobile">
                {renderDays([mobileDay], false)}
            </div>
        </div>
    )
}

export default UserCalendar
